/**
 * FeaturesModal — the "All features" overlay opened by the "View all features"
 * button. Lists every feature grouped by its API category (`featureCategories`),
 * sorted with the largest categories first. Falls back to a single "Features"
 * group if an offer has no categories.
 *
 * Props:
 *   - offer  {Object|null} — the offer whose features to show; null = closed
 *   - onHide {()=>void}
 */
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useStrings, featureLabel } from './i18n';
import { IconCheck } from './icons';

export default function FeaturesModal({ offer, onHide }) {
    const t = useStrings();
    // Order is set in mapProperty (priority categories — pool / views / parking /
    // Setting — first, then largest-first), so no re-sort here.
    const categories = offer
        ? (offer.featureCategories && offer.featureCategories.length
            ? offer.featureCategories
            : [{ category: t.features, items: offer.facilities.length ? offer.facilities : [t.infoOnRequest] }])
        : [];

    return (
        <Modal show={Boolean(offer)} onHide={onHide} centered dialogClassName="rs-features-modal">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>{t.allFeatures}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="rs-proto">
                    <div className="rs-feat-cats">
                        {categories.map((cat) => (
                            <div className="rs-feat-cat" key={cat.category}>
                                <div className="rs-feat-cat__h">{cat.category}</div>
                                <ul className="rs-feat-cat__list">
                                    {cat.items.map((f) => (
                                        <li className="rs-facil" key={f}>
                                            <span className="rs-facil__check"><IconCheck size={12} /></span>{featureLabel(t, cat.category, f)}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
